import { aiOpenapiClient, unwrapResult } from '@/api/openapi-client';
import { useRestaurantStore } from '@/stores/restaurant.store';
import type { CreateMenuFromSourcesBody, MenuFromSourcesAccepted } from '@restaurant/api-client';
import { useMutation, useQueryClient } from '@tanstack/react-query';

export function useCreateMenuFromSources() {
  const restaurantId = useRestaurantStore((s) => s.selectedRestaurantId) ?? '';
  const qc = useQueryClient();
  return useMutation({
    mutationFn: async (body: CreateMenuFromSourcesBody) =>
      unwrapResult<MenuFromSourcesAccepted>(
        await aiOpenapiClient.POST('/restaurants/{restaurantId}/ai/menus/create-from-sources', {
          params: { path: { restaurantId } },
          body,
        }),
      ),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['menu'] }),
  });
}
